import { api } from './api';
import type { Permission } from '@apptypes/index';

export const permissionsService = {
  list: (scope?: string) =>
    api.get<Permission[]>('/admin/permissions', scope ? { scope } as Record<string, unknown> : undefined),
  create: (data: { code: string; name: string; scope?: string; description?: string }) =>
    api.post<Permission>('/admin/permissions', data),
};
